import React, { useEffect, useState } from 'react';
import {Table, Container, Button} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import Page from '../../pagination/pagination';
import { GetDaywiseItineraries } from '../../../entities/action/action';

const ItineraryList = (props)=>{
    const { onEditDaywise } = props;
    const [dataSet,updateDataSet] = useState([]);
    const [count,updateCount] = useState(0)
    const postPerPage = 20;
    const [currentPage,updateCurrentPage] = useState(1);
    const indexOfLast = currentPage*postPerPage;
    const indexOfFirst = indexOfLast - postPerPage;
    const currentPosts = dataSet.slice(indexOfFirst,indexOfLast);
    const handleChangePage = (event,value)=>{
        updateCurrentPage(value)
    }
    useEffect(()=>{
        updateCount(Math.ceil(dataSet.length/postPerPage))
    },[dataSet])

    useEffect(() => {
            (async () => {
              try {
                const arr = await GetDaywiseItineraries();
                if (arr?.success) {
                  updateDataSet(Array.isArray(arr.itineraries) ? arr.itineraries : []);
                }
              } catch {
                updateDataSet([]);
              }
            })();
          }, []);

    const setStatus = async(status, id) => {
        const token = localStorage.getItem('token');
        const authHeader = `Bearer ${token}`
        const res = await fetch(`https://api.zupptravel.com/api/v1/daywise-itinerary/${id}/status/${status}`, {
            method: "get",
            headers: {
            "Content-Type": "application/json",
            'Authorization': authHeader
            }
        });

        const json = await res.json();

        if (json?.success) {
            alert("Updated Status Successfully!");
            const arr = await GetDaywiseItineraries();
            if (arr?.success) {
              updateDataSet(Array.isArray(arr.itineraries) ? arr.itineraries : []);
            }
        } else {
            alert("Error! Please try again later");
        }
    }
 
    return(
        <Container fluid style={{padding:'0', maxWidth:'100%', minWidth:0}}>
            <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <Table striped bordered hover className="mb-0">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Holiday ID</th>
                        <th>Itinerary</th>
                        <th>Route</th>
                        <th>Days</th>
                        <th>Holiday Name</th>
                        <th>Flights</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        currentPosts.length>0?currentPosts.map((data,key)=>
                            <tr key={data.id ?? key}>
                                <td>{indexOfFirst + key + 1}</td>
                                <td>{data.holidayId}</td>
                                <td>{data.itineraryName || '—'}</td>
                                <td>{data.route || '—'}</td>
                                <td>{data.totalDays ?? data.day ?? '—'}</td>
                                <td>{data.holidayName || '—'}</td>
                                <td>
                                    {data.flightsIncluded === true
                                        ? `Included${data.flightsNote ? ` — ${data.flightsNote}` : ''}`
                                        : data.flightsIncluded === false
                                        ? `Not included${data.flightsNote ? ` — ${data.flightsNote}` : ''}`
                                        : '—'}
                                </td>
                                <td className={classes.CenterRow}>
                                    {onEditDaywise && data?.id ? (
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            className="mr-2"
                                            onClick={() => onEditDaywise(data.id)}
                                        >
                                            Edit
                                        </Button>
                                    ) : null}
                                    {data.isActive ?
                                        <Button variant="success" size="sm" onClick={()=>setStatus(false,data?.id)}>Active</Button>:
                                        <Button variant="danger" size="sm" onClick={()=>setStatus(true,data?.id)}>Inactive</Button>
                                    }
                                </td>
                            </tr>
                        ):
                            <tr>
                                <td colSpan={8} style={{ textAlign: 'center', padding: '24px' }}>
                                    No itineraries found. Add itineraries via Day-wise Itinerary.
                                </td>
                            </tr>
                    }
                </tbody>
            </Table>
            </div>
            <div style={{display:'flex',justifyContent:'center',margin:'15px 0'}}>
                {count > 0 ? (
                <Page count={count} change={handleChangePage} page={currentPage}/>
                ) : null} 
            </div>
        </Container>
    )
}
export default ItineraryList;